const namespace = 'UrlMap';

export const REQUEST_URLMAP = `${namespace}/REQUEST_URLMAP`;
export const RECEIVE_URLMAP_SUCCESS = `${namespace}/RECEIVE_URLMAP_SUCCESS`;
export const RECEIVE_URLMAP_ERROR = `${namespace}/RECEIVE_URLMAP_ERROR`;
